import { ROTA_APIS } from "@/api_framework/api_config";
import { IRotaErrorListResponse, IRotaManagementErrorProps } from "@/api_framework/api_modals/Rota";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setRotaErrorList } from "@/app_redux/reducers/slices/auth/rota_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useRotaErrorListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (error_id: IRotaManagementErrorProps) => {
      // dispatch(
      //   setLoading({
      //     key: "isOrgServicesInProgress",
      //     status: true,
      //   })
      // );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .post(ROTA_APIS?.ROTA_ERROR_LIST_API?.baseURL ?? "", error_id, {
            params: {},
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IRotaErrorListResponse>) => {
            if (res.data.status === true) {
              dispatch(setRotaErrorList({ data: res.data.data }));
              dispatch(
                setLoading({
                  key: "isOrgServicesInProgress",
                  status: false,
                }),
              );
            } else {
              // dispatch(setRotaErrorList({ data: [] }));
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              toast.error("Fetching Error list failed");
            }
            if (e.status === 400) {
              toast.error("Fetching Error list failed");
            }
            if (e.status === 500) {
              toast.error("Server Error: " + e.message);
            }
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
